var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFireSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic \xC2\xB7 fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16086 0.766992C6.11848 0.731761 6.06826 0.707234 6.01442 0.69548C5.96058 0.683726 5.9047 0.685088 5.8515 0.699453C5.79829 0.713817 5.74932 0.740763 5.70871 0.778017C5.66811 0.815272 5.63705 0.861744 5.61816 0.913516L4.67285 3.50926L3.63473 2.50336C3.59986 2.46954 3.55823 2.4435 3.51257 2.42695C3.46691 2.41039 3.41826 2.4037 3.36983 2.40731C3.32139 2.41093 3.27427 2.42476 3.23158 2.44791C3.18888 2.47106 3.15157 2.50299 3.12211 2.5416C2.19141 3.76105 1.71875 4.98781 1.71875 6.1875C1.71875 7.19035 2.11713 8.15213 2.82625 8.86125C3.53537 9.57037 4.49715 9.96875 5.5 9.96875C6.50285 9.96875 7.46463 9.57037 8.17375 8.86125C8.88287 8.15213 9.28125 7.19035 9.28125 6.1875C9.28125 3.63301 7.09887 1.54687 6.16086 0.766992ZM7.90152 6.58883C7.81239 7.08671 7.57285 7.54533 7.21516 7.90294C6.85747 8.26056 6.3988 8.5 5.9009 8.58902C5.88202 8.59226 5.8629 8.59384 5.84375 8.59375C5.75752 8.59373 5.67445 8.5613 5.61102 8.5029C5.54758 8.4445 5.50841 8.36439 5.50127 8.27846C5.49413 8.19253 5.51955 8.10705 5.57248 8.03898C5.62541 7.97092 5.70199 7.92523 5.78703 7.91098C6.49902 7.79109 7.10316 7.18695 7.22391 6.47367C7.23918 6.38376 7.28954 6.30359 7.36392 6.25081C7.43829 6.19803 7.53059 6.17696 7.62051 6.19223C7.71042 6.2075 7.79059 6.25786 7.84337 6.33224C7.89615 6.40662 7.91722 6.49891 7.90195 6.58883H7.90152Z",
    fill: "#FB923C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFireSmall);
export default __webpack_public_path__ + "static/media/ic-fire-small.80debb7d4838d90c183564c5cb86a4c9.svg";
export { ForwardRef as ReactComponent };